import React, { forwardRef, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';

const SwiperCardBack = forwardRef(({ slides, cardID }, ref) => {
  return (
    <Swiper
      modules={[Navigation]}
      slidesPerView={1}
      ref={ref}
      navigation={{
        prevEl: `.swiper-button-prev__card-back-${cardID}`,
        nextEl: `.swiper-button-next__card-back-${cardID}`,
        addIcons: false,
      }}
    >
      {slides.map((slide, i) => (
        <SwiperSlide key={i}>{slide}</SwiperSlide>
      ))}
    </Swiper>
  );
});

SwiperCardBack.displayName = 'SwiperCardBack';

export default SwiperCardBack;
